export default [
  {
    path: '/institutions',
    name: 'institutions',
    component: () => import('@/views/modules/skeleton/admin/Institutions/Institutions.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Institutions',
          active: true,
          // back: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/add-institution',
    name: 'create_institution',
    component: () => import('@/views/modules/skeleton/admin/Institutions/CreateInstitution.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Add Institution',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/edit-institution/:id',
    name: 'edit_institution',
    component: () => import('@/views/modules/skeleton/admin/Institutions/CreateInstitution.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Edit Institution',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/show-institution/:id',
    name: 'show_institution',
    component: () => import('@/views/modules/skeleton/admin/Institutions/InstitutionDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Institution Details',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
  {
    path: '/institution-profile/:id?',
    name: 'institution_profile',
    component: () => import('@/views/modules/skeleton/admin/Institutions/InstitutionProfile.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'My Institution',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
]
